import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { Beforeunload } from 'react-beforeunload';
import ShaunEllisPopup from "../../components/ShaunEllisPopup";
import NPSPopup from "../../components/NPSPopup";
import { RESET_SE_DATA, RESET_NPS_DATA } from "../../redux/actions/types"
import { setCookie, getCookie, toggleCookie } from "../../utils/cookie"

const BeforeTabClose = () => {
    let count = 0;
    const isUserTokenPresent = useSelector(store => store?.authentication?.user_token ? true : false)
    const walkthrough = useSelector(store => store?.profileDetails?.walkthrough)
    const shaunEllisResponse = useSelector(store => store?.profileDetails?.shaunEllisResponse)
    const NPSResponse = useSelector(store => store?.profileDetails?.NPSResponse)
    const dispatch = useDispatch()
    const [openSEPopup, setOpenSEPopup] = useState(false)
    const [openNPSPopup, setOpenNPSPopup] = useState(false)

    const dateDiff = (date) => {
        var newDate = new Date()
        return newDate - new Date(date)
    }

    const exitListener = (e) => {
        if (e.clientY <= 0 && walkthrough?.profile_walkthrough && walkthrough?.content_player_walkthrough && getCookie('modalShown') !== 'true') {
            if (isUserTokenPresent && count < 1) {
                if (NPSResponse) toggleCookie('toggle', 'SE')
                if (shaunEllisResponse) toggleCookie('toggle', 'NPS')
                if (getCookie('toggle') === 'NPS') {
                    !NPSResponse && setOpenNPSPopup(true)
                    setOpenSEPopup(false)
                    count++
                    setCookie('modalShown', true)
                    toggleCookie('toggle', 'SE')
                }
                else if (getCookie('toggle') === 'SE') {
                    !shaunEllisResponse && setOpenSEPopup(true)
                    setOpenNPSPopup(false)
                    count++
                    setCookie('modalShown', true)
                    toggleCookie('toggle', 'NPS')
                }
                else return
            }
        }
    }

    useEffect(() => {
        if (isUserTokenPresent) {
            !getCookie('toggle') && toggleCookie('toggle', 'SE')
            var SE_DATE = shaunEllisResponse?.updated_at
            var NPS_DATE = NPSResponse?.updated_at
            var interval = 30 * 24 * 60 * 60 * 1000 // 30 days

            if (SE_DATE && dateDiff(SE_DATE) > interval) dispatch({ type: RESET_SE_DATA })
            if (NPS_DATE && dateDiff(NPS_DATE) > interval) dispatch({ type: RESET_NPS_DATA })

            document.getElementById('root').addEventListener('mouseout', (e) => exitListener(e))
        }

        return isUserTokenPresent && document.getElementById('root').removeEventListener('mouseout', (e) => exitListener(e))
    }, [isUserTokenPresent])

    return (
        <Beforeunload onBeforeunload={(e) => {
            // if (isUserTokenPresent && count < 2) {
            //     if (toggle === 'NPS' && !NPSResponse) {
            //         setOpenNPSPopup(true)
            //         setOpenSEPopup(false)
            //         toggle = 'SE'
            //         count++
            //     }
            //     else if (!shaunEllisResponse) {
            //         setOpenNPSPopup(false)
            //         setOpenSEPopup(true)
            //         toggle = 'NPS'
            //         count++
            //     }
            //     else return

            //     e.preventDefault()
            //     return 'Please Fill in Feedback!'
            // }
        }} >
            <ShaunEllisPopup openSEPopup={openSEPopup} setOpenSEPopup={setOpenSEPopup} />
            <NPSPopup openNPSPopup={openNPSPopup} setOpenNPSPopup={setOpenNPSPopup} />
        </Beforeunload>
    )
}

export default BeforeTabClose